import supabase from "../config/supabaseClient"
import { useEffect, useState } from "react"


//components
import BuildSentence from "../components/FullSentence"

const Home = () => {
  const [fetchError, setFetchError] = useState(null)
  const [sentences, setSentences] = useState(null)

  const[adjective1, setAdjective1] = useState('')
  const[noun1, setNoun1] = useState('')
  const[adverb, setAdverb] = useState('Will')
  const[verb, setVerb] = useState('')
  const[adjective2, setAdjective2] = useState('')
  const[noun2, setNoun2] = useState('')
  const[formError, setFormError] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!adjective1 || !noun1 || !adverb || !verb || !adjective2 || !noun2) {
      setFormError('I cannae re-animate without words')
      return
    }

    const {data, error} = await supabase
      .from('sentences')
      .insert([{ adjective1, noun1, adverb, verb, adjective2, noun2 }])

      if(error) {
        console.log('cannae reanimate without words')
      }
      if(data) {
        console.log(data)
        setFormError(null)
      }
  }

  useEffect(() => {
    const fetchSentences = async () => {
      const {data, error} = await supabase
        .from('sentences')
        .select()

        if(error) {
          setFetchError('Could Not fetch the sentence')
          setSentences(null)
          console.log(error)
        }
        if(data) {
          setSentences(data)
          setFetchError(null)
        }
      }
    
      fetchSentences()

  }, [])
  
  return (
    <div>
      <div className="page home">
        <form onSubmit = {handleSubmit}>
          <label htmlFor="adjective1">Adjective:</label>
          <input
            type="text"
            id="adjective1"
            value={adjective1}
            onChange={(e) => setAdjective1(e.target.value)}
          />

          <label htmlFor="noun1">Noun:</label>
          <input
            type="text"
            id="noun1"
            value={noun1}
            onChange={(e) => setNoun1(e.target.value)}
          />

          <label htmlFor="adverb">Auxillary Verb:</label>
          <select id="adverb" value={adverb} onChange={(e) => setAdverb(e.target.value)}>
            <option value="Will">Will</option>
            <option value="Can">Can</option>
            <option value="Could">Could</option>
            <option value="May">May</option>
            <option value="Might">Might</option>
            <option value="Shall">Shall</option>
            <option value="Would">Would</option>
            <option value="Should">Should</option>
            <option value="Must">Must</option>
            <option value="Ought to">Ought To</option>
          </select>

          <label htmlFor="verb">Verb:</label>
          <input
            type="text"
            id="verb"
            value={verb}
            onChange={(e) => setVerb(e.target.value)}
          />

          <label htmlFor="adjective2">Adjective:</label>
          <input
            type="text"
            id="adjective2"
            value={adjective2}
            onChange={(e) => setAdjective2(e.target.value)}
          />

          <label htmlFor="noun2">Noun:</label>
          <input
            type="text"
            id="noun2"
            value={noun2}
            onChange={(e) => setNoun2(e.target.value)}
          />

          <button>Create Corpse</button>

          {formError && <p className='error'>{formError}</p>}
        </form>

      </div>


      <div className="page home">
        {fetchError && (<p>fetchError</p>)}
        {sentences && (
          <div className="sentences">
            {sentences.map(sentence => (
              <BuildSentence key={sentences.id} sentence={sentence}/>
            ))}

          </div>
        )}
      </div>
    </div>
  )
}
export default Home